// @ts-ignore
import { Context } from '@nuxt/types/app'

export default function ({ $config, $axios }: Context): void {
  // for client baseURL
  $axios.setBaseURL($config.baseUrl)
}
